import React from "react";
import { globalIV, globalSalt } from "../../../config/constant";
import { AesUtil } from "../../../JS/AesUtil";

const checkPreCheckinWidgetState = (props, latestServerTimeCallback) => {

    const aesUtil = new AesUtil(128, 1000);

    if (props.preCheckInEnabled) {
        if ((localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) && (props.serverTimeDate || latestServerTimeCallback)) {

            let checkInDataPayload = localStorage.getItem("X_CHECKIN_PQ_DATA") ? JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", localStorage.getItem("X_CHECKIN_PQ_DATA"))) : JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", sessionStorage.getItem("X_CHECKIN_PQ_DATA")))
            if (checkInDataPayload && checkInDataPayload.checkinDate && !props.mobileCheckInDisabled) {

                const serverDateTime = new Date(latestServerTimeCallback ? latestServerTimeCallback.replace("Z", "") : props.serverTimeDate.replace("Z", ""));
                const checkinStartDateTime = new Date(`${checkInDataPayload.checkinDate}T${props.checkInStartTime ? props.checkInStartTime : "00:00:00"}`);
                const earlyCheckinStartDateTime = props.earlyCheckInStartTime && new Date(`${checkInDataPayload.checkinDate}T${props.earlyCheckInStartTime}`);

                console.log("checking pre checkin widget as per server time")
                console.log(serverDateTime)
                console.log(checkinStartDateTime)
                console.log(earlyCheckinStartDateTime)

                if (earlyCheckinStartDateTime) {
                    if (serverDateTime < earlyCheckinStartDateTime) {

                        props.setPreCheckInWidgetState("pre check-in")
                        return "pre check-in"
                    } else if (serverDateTime >= earlyCheckinStartDateTime && serverDateTime < checkinStartDateTime) {
                        // If server time is between early checkin and checkin
                        props.setPreCheckInWidgetState("early check-in")
                        return "early check-in"
                    } else if (serverDateTime >= checkinStartDateTime) {
                        // If server time is greater than or equal to checkin time
                        props.setPreCheckInWidgetState("mobile check-in")
                        return "mobile check-in"
                    }
                } else {

                    if (serverDateTime >= checkinStartDateTime) {
                        props.setPreCheckInWidgetState("mobile check-in")
                        return "mobile check-in"
                    } else {
                        props.setPreCheckInWidgetState("pre check-in")
                        return "pre check-in"
                    }
                }
            } else {
                props.setPreCheckInWidgetState("pre check-in")
                return "pre check-in"
            }
        } else {
            props.setPreCheckInWidgetState("pre check-in")
            return "pre check-in"
        }
    } else {
        props.setPreCheckInWidgetState("mobile check-in")
        return "mobile check-in"
    }
}


export default checkPreCheckinWidgetState;